import {
  Checkbox,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import TableDesign from "../../../../components/common/table/TableDesign";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import FormField from "../../../../components/common/FormField";
import { FC } from "react";
import { DeleteOutlined } from "@mui/icons-material";
import CustomButton from "../../../../components/common/button/CustomButton";

const RenderEstimateTable: FC<any> = ({
  estimateForm,
  onChangeAction,
  handleDeleteServiceRow,
  onAddVehicle,
  handleDeleteSubContractorRow,
  vehiclesOptions,
  subContractorOptions,
  onBlurAction,
  error,
  tableHeadding,
  tableContent,
  fields,
  additionRow = "",
  section = "",
  disabled = false,
  screenType,
  renderExtraRows,
  handleRemoveVehicle,
}) => {
  const { leadDetails } = useSelector((state: any) => state.lead);

  const { userProfile } = useSelector((state: any) => state?.user);

  const getBaseServiceTypeKey = (serviceType: string) =>
    String(serviceType || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[,_-]+/g, "")
      .replace(/_primary\d*$/, "");

  const getServiceNameKey = (service: any) =>
    String(
      service?.typeName ||
        service?.name ||
        service?.service_name ||
        service?.type ||
        "",
    )
      .toLowerCase()
      .replace(/[,_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const isRemovalRow = (service: any) =>
    getBaseServiceTypeKey(service?.type || service?.typeName || "") ===
      "removal" ||
    getServiceNameKey(service) === "removal" ||
    getServiceNameKey(service) === "removal door to door" ||
    getServiceNameKey(service) === "removal, door to door";

  const isFullPackRow = (service: any) => {
    const typeKey = getBaseServiceTypeKey(
      service?.type || service?.typeName || service?.service_name || "",
    );
    const nameKey = getServiceNameKey(service);

    return (
      typeKey === "fullpack" ||
      typeKey === "fullpacking" ||
      nameKey === "fullpack" ||
      nameKey === "fullpacking"
    );
  };

  // Helper function to get available subcontractor options for a specific row
  const getAvailableSubContractorOptions = (currentRowIndex: number) => {
    if (
      section !== "subcontractorCharges" ||
      !estimateForm?.subcontractorCharges
    ) {
      return subContractorOptions;
    }
    // Get all selected subcontractor IDs except the current row
    const selectedSubContractorIds = estimateForm.subcontractorCharges
      .map((item: any, index: number) =>
        index !== currentRowIndex ? item.subContractorId : null,
      )
      .filter((id: any) => id !== null && id !== "");

    // Filter out already selected subcontractors
    return subContractorOptions.filter(
      (option: any) => !selectedSubContractorIds.includes(option.id),
    );
  };

  const isVehicleRowComplete = (idx: number) => {
    const vehicles = estimateForm?.services?.[idx]?.vehicles || [];

    if (vehicles.length === 0) return false;

    return vehicles.every(
      (v: any) =>
        v?.vehicleTypeId &&
        v?.vehicleQty !== null &&
        v?.vehicleQty !== undefined &&
        v?.fuelCharge !== null &&
        v?.fuelCharge !== undefined,
    );
  };

  const restrictedGroups = [
    ["full pack", "full packing"],
    ["removal", "removal,door to door"],
  ];

  const getMatchedRestrictedGroup = (value: string) => {
    const normalizedValue = value?.toLowerCase()?.trim();

    return restrictedGroups.find((group) => group.includes(normalizedValue));
  };

  const isDuplicateRestrictedType = (
    currentValue: string,
    currentRowIndex: number,
  ) => {
    const normalizedValue = currentValue?.toLowerCase()?.trim();

    const matchedGroup = getMatchedRestrictedGroup(normalizedValue);

    if (!matchedGroup) return false;

    return estimateForm?.services?.some((service: any, index: number) => {
      if (index === currentRowIndex) return false;

      const existingType = service?.typeName?.toLowerCase()?.trim();

      return matchedGroup.includes(existingType);
    });
  };

   /**
   * Quote accepted status.
   *
   * API uses `accepted_status`
   * Frontend may use `acceptedStatus`
   */
  const acceptedStatus = String(
    estimateForm?.accepted_status ??
      estimateForm?.acceptedStatus ??
      "",
  ).toLowerCase();

  const isAcceptedQuote = acceptedStatus === "accepted";
 /**
   * Delete icon rules:
   *
   * 1. Accepted quote + serviceId exists
   *    => Hide delete
   *
   * 2. Initiated / Quoted + isAccepted === true
   *    => Hide delete
   *
   * 3. Initiated / Quoted + isAccepted === false
   *    => Show delete
   */
  const shouldHideServiceDelete = (row: any) => {
    // Accepted quote:
    // serviceId exists => don't allow delete
    if (isAcceptedQuote && row?.serviceId) {
      return true;
    }

    // Non-accepted quote:
    // isAccepted true => don't allow delete
    if (!isAcceptedQuote && row?.isAccepted === true) {
      return true;
    }

    return false;
  };


  return (
    tableContent &&
    tableContent.length && (
      <TableDesign
        tableHeadings={tableHeadding}
        cellColor={"#637381"}
        fontWeight={400}
        stickyHeader={false}
        // pagination={pagination}
        filterOption={null}
        setFilterOption={() => {}}
        extraClass="estimateTable"
      >
        <>
          {tableContent.length > 0
            ? tableContent.map((row: any, idx: number) => (
                <>
                  {section === "services" && idx === 2 && (
                    <TableRow sx={{ height: "28px" }}>&nbsp;</TableRow>
                  )}
                  <TableRow key={`${section}-${idx}`}>
                    {fields.map((field: any, fieldIdx: number) => {
                      return (
                        <TableCell
                          sx={{
                            width:
                              field.id === "vehicleTypeId"
                                ? "stretch"
                                : fieldIdx === 0
                                  ? "132px"
                                  : row?.name === "Packing Materials"
                                    ? screenType === "quotation"
                                      ? "124px"
                                      : "318px"
                                    : field?.width || "auto",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {field?.type === "staticText" ||
                          (section === "services" &&
                            // field?.id === "typeName" &&
                            field?.id === "demo" &&
                            (idx < 2 ||
                              (idx >= 2 &&
                                (row?.is_accepted || row?.isAccepted)))) ? (
                            field?.id === "provisionalDate" &&
                            isFullPackRow(row) ? (
                              leadDetails?.lead?.moving_on_date &&
                              row?.day !== null &&
                              row?.day !== undefined &&
                              Number(row.day) !== 0 ? (
                                `${dayjs(leadDetails?.lead?.moving_on_date)
                                  .add(
                                    Number(row.day) -
                                      (Number(tableContent?.[0]?.day) || 2),
                                    "day",
                                  )
                                  .format(
                                    userProfile?.dateFormat ?? "DD/MM/YYYY",
                                  )}`
                              ) : leadDetails?.lead?.packing_on_date ? (
                                dayjs(
                                  leadDetails?.lead?.packing_on_date,
                                ).format(
                                  userProfile?.dateFormat ?? "DD/MM/YYYY",
                                )
                              ) : (
                                <Typography
                                  style={{
                                    fontSize: "10px",
                                    textAlign: "center",
                                    fontWeight: 600,
                                  }}
                                >
                                  N/A
                                </Typography>
                              )
                            ) : idx === 0 && field?.id === "provisionalDate" ? (
                              leadDetails?.lead?.moving_on_date ? (
                                `${dayjs(
                                  leadDetails?.lead?.moving_on_date,
                                ).format(
                                  userProfile?.dateFormat ?? "DD/MM/YYYY",
                                )}`
                              ) : (
                                <Typography
                                  style={{
                                    fontSize: "10px",
                                    textAlign: "center",
                                    fontWeight: 600,
                                  }}
                                >
                                  N/A
                                </Typography>
                              )
                            ) : idx >= 1 && field?.id === "provisionalDate" ? (
                              leadDetails?.lead?.moving_on_date &&
                              row?.day !== null &&
                              row?.day !== undefined &&
                              Number(row.day) !== 0 ? (
                                `${dayjs(leadDetails?.lead?.moving_on_date)
                                  .add(
                                    Number(row.day) -
                                      (Number(tableContent?.[0]?.day) || 2),
                                    "day",
                                  )
                                  .format(
                                    userProfile?.dateFormat ?? "DD/MM/YYYY",
                                  )}`
                              ) : (
                                <Typography
                                  style={{
                                    fontSize: "10px",
                                    textAlign: "center",
                                    fontWeight: 600,
                                  }}
                                >
                                  N/A
                                </Typography>
                              )
                            ) : (
                              <span
                                style={{
                                  color:
                                    idx >= 0 &&
                                    section === "services" &&
                                    (row?.is_accepted || row?.isAccepted) &&
                                    // row?.typeName !== "Full Pack" &&
                                    row?.typeName !== "Removal"
                                      ? "#02906F"
                                      : "inherit",
                                  fontWeight:
                                    idx >= 0 &&
                                    section === "services" &&
                                    (row?.is_accepted || row?.isAccepted) &&
                                    // row?.typeName !== "Full Pack" &&
                                    row?.typeName !== "Removal"
                                      ? 600
                                      : "none",
                                }}
                              >
                                {row[field?.id]}
                                {/* {formatText(row[field?.id] || "")} */}
                                {["Removal"].includes(row?.typeName) && (
                                  <span style={{ color: "#D32F2F" }}>*</span>
                                )}
                              </span>
                            )
                          ) : idx >= 0 &&
                            idx <= 1 &&
                            field?.id === "name" &&
                            section === "ancillaries" ? (
                            row[field?.id]
                          ) : field?.type === "checkbox" ? (
                            <Checkbox
                              sx={{ marginTop: "16px", marginLeft: "16px" }}
                              disabled={disabled}
                              checked={
                                estimateForm
                                  ? section &&
                                    estimateForm[section] &&
                                    estimateForm[section][idx]
                                    ? estimateForm[section][idx][field.id]
                                    : estimateForm[field.id]
                                  : ""
                              }
                              onChange={(e: any) =>
                                onChangeAction(
                                  e,
                                  section,
                                  section === "generalInfo" ? 0 : idx,
                                  field?.valueFormat,
                                )
                              }
                              name={field?.id}
                              id={field?.id}
                              color="primary"
                            />
                          ) : (
                            <FormField
                              // key={field.id}
                              onPaste={(e: any) =>
                                field?.id === "description"
                                  ? ""
                                  : e.preventDefault()
                              }
                              onKeyDown={(event: any) => {
                                if (!field?.patternAllowed) return;

                                if (
                                  event.ctrlKey ||
                                  event.metaKey ||
                                  [
                                    "Backspace",
                                    "Tab",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "ArrowUp",
                                    "ArrowDown",
                                    "Delete",
                                    "Home",
                                    "End",
                                    "Enter",
                                  ].includes(event.key)
                                ) {
                                  return;
                                }

                                const target = event.target as HTMLInputElement;
                                const selectionStart =
                                  target.selectionStart ?? target.value.length;
                                const selectionEnd =
                                  target.selectionEnd ?? target.value.length;
                                const nextValue =
                                  target.value.slice(0, selectionStart) +
                                  event.key +
                                  target.value.slice(selectionEnd);

                                if (!field.patternAllowed.test(nextValue)) {
                                  event.preventDefault();
                                }
                              }}
                              {...{
                                ...field,
                                id:
                                  section === "generalInfo"
                                    ? field?.id
                                    : field?.id,
                                value: estimateForm
                                  ? section === "generalInfo"
                                    ? estimateForm[section]?.[row.id] === 0
                                      ? 0
                                      : estimateForm[section]?.[row.id] || ""
                                    : section === "services" &&
                                        estimateForm[section] &&
                                        estimateForm[section][idx] &&
                                        [
                                          "vehicleTypeId",
                                          "vehicleQty",
                                          "fuelCharge",
                                        ].includes(field.id)
                                      ? estimateForm[section][idx].vehicles &&
                                        estimateForm[section][idx].vehicles[0]
                                        ? estimateForm[section][idx]
                                            .vehicles[0][field.id] === 0
                                          ? 0
                                          : estimateForm[section][idx]
                                              .vehicles[0][field.id] || ""
                                        : ""
                                      : section === "services" &&
                                          field?.id === "typeName" &&
                                          estimateForm[section] &&
                                          estimateForm[section][idx]
                                        ? (() => {
                                            const rowData =
                                              estimateForm[section][idx] || {};
                                            const savedTypeName = String(
                                              rowData?.typeName || "",
                                            ).trim();

                                            if (savedTypeName) {
                                              return savedTypeName;
                                            }

                                            const rowTypeId =
                                              getBaseServiceTypeKey(
                                                rowData?.type || "",
                                              );

                                            if (rowTypeId) {
                                              const matchedOption = (
                                                field?.options || []
                                              ).find(
                                                (option: any) =>
                                                  getBaseServiceTypeKey(
                                                    option?.type ||
                                                      option?.id ||
                                                      "",
                                                  ) === rowTypeId,
                                              );

                                              if (matchedOption?.name) {
                                                return matchedOption.name;
                                              }
                                            }

                                            return rowData?.typeName || "";
                                          })()
                                        : section === "services" &&
                                            estimateForm[section] &&
                                            estimateForm[section][idx]
                                          ? estimateForm[section][idx][
                                              field.id
                                            ] === 0
                                            ? 0
                                            : estimateForm[section][idx][
                                                field.id
                                              ] || ""
                                          : section &&
                                              estimateForm[section] &&
                                              estimateForm[section][idx]
                                            ? estimateForm[section][idx][
                                                field.id
                                              ]
                                            : estimateForm[field.id]
                                  : "",
                                variant: "outlined", // Adding this variant prop
                                isNonMarginTop: true,
                                ...(field?.type === "select" && {
                                  options: (() => {
                                    if (
                                      section === "services" &&
                                      field?.id === "typeName"
                                    ) {
                                      const currentValue =
                                        getServiceNameKey(row) ||
                                        getBaseServiceTypeKey(row?.type || "");
                                      const filteredOptions =
                                        field?.options || [];

                                      const hasCurrentOption =
                                        filteredOptions.some(
                                          (option: any) =>
                                            getServiceNameKey(option) ===
                                            currentValue,
                                        );

                                      if (
                                        !hasCurrentOption &&
                                        row?.typeName &&
                                        !(idx > 0 && isRemovalRow(row))
                                      ) {
                                        return [
                                          {
                                            id: row?.typeName,
                                            name: row?.typeName,
                                          },
                                          ...filteredOptions,
                                        ];
                                      }

                                      return filteredOptions;
                                    }

                                    if (field?.id === "subContractorId") {
                                      return getAvailableSubContractorOptions(
                                        idx,
                                      );
                                    }

                                    if (field?.id === "vehicleTypeId") {
                                      return vehiclesOptions;
                                    }

                                    return field?.options || [];
                                  })(),
                                }),
                                disabled:
                                section === "services"
                                    ? !!row?.serviceId && estimateForm?.accepted_status?.toLowerCase() === "accepted" :
                                   typeof field?.disabled === "function"
                                    ? field.disabled(row, idx)
                                    : field?.disabled || disabled,
                                InputProps: {
                                  ...field?.inputProps,
                                  autocomplete: "off",
                                  sx: {
                                    // ...field?.inputProps?.sx,
                                    padding: "2px 4px",
                                    height: "20px",
                                    ...(section === "services" &&
                                    field?.id === "typeName"
                                      ? { fontSize: "13px" }
                                      : {}),
                                  },
                                },
                                onChange: (e: any) => {
                                  onChangeAction(
                                    e,
                                    section,
                                    // section === "generalInfo" ? 0 :
                                    idx,
                                    field?.valueFormat,
                                  );
                                },
                                onBlur: (e: any) => {
                                  //                                 if (field?.id === "typeName") {
                                  //   const value = e.target.value?.toLowerCase()?.trim();

                                  //   if (isDuplicateRestrictedType(value, idx)) {
                                  //     alert(
                                  //       `"${e.target.value}" already exists. Only one service from this category is allowed.`,
                                  //     );

                                  //     // clear value
                                  //     onChangeAction(
                                  //       {
                                  //         target: {
                                  //           name: field.id,
                                  //           value: "",
                                  //         },
                                  //       },
                                  //       section,
                                  //       idx,
                                  //       field?.valueFormat,
                                  //     );

                                  //     return;
                                  //   }
                                  // }
                                  if (field?.id === "typeName") {
                                    const value = e.target.value
                                      ?.toLowerCase()
                                      ?.trim();

                                    if (isDuplicateRestrictedType(value, idx)) {
                                      alert(
                                        `"${e.target.value}" already exists. Only one service from this category is allowed.`,
                                      );

                                      // clear value
                                      onChangeAction(
                                        {
                                          target: {
                                            name: field.id,
                                            value: "",
                                          },
                                        },
                                        section,
                                        idx,
                                        field?.valueFormat,
                                      );

                                      // focus back to same field
                                      setTimeout(() => {
                                        e.target.focus();
                                      }, 0);

                                      return;
                                    }
                                  }

                                  onBlurAction?.(e);
                                },
                                error:
                                  error && section
                                    ? error[section]
                                      ? error[section][idx]
                                      : false
                                    : error?.[field.id],
                              }}
                            />
                          )}
                        </TableCell>
                      );
                    })}

                    {/* Add Delete Icon for the row */}
                    {fields &&
                      fields.length &&
                      fields.map((field: any, fieldIdx: number) => {
                        return (
                          // Delete icon for services section
                          (section === "services" &&
                          field?.id === "typeName" &&
                          idx >= 1 && // Ensure it's an extra service row
                          !shouldHideServiceDelete(row) ? ( // Only allow deleting unaccepted rows (regardless of typeName)
                            <TableCell sx={{ width: "20px" }}>
                              <IconButton
                                sx={{ padding: "0px" }}
                                onClick={() => handleDeleteServiceRow(idx)}
                                color="error"
                                disabled={disabled && estimateForm[section]?.hasFinalInvoice} // Disable delete button if the row is disabled
                              >
                                <DeleteOutlined />
                              </IconButton>
                            </TableCell>
                          ) : null) ||
                          // Delete icon for subcontractorCharges section
                          (section === "subcontractorCharges" &&
                          field?.id === "subContractorId" &&
                          tableContent.length > 1 ? ( // Allow delete only if more than 1 row
                            <TableCell sx={{ width: "20px" }}>
                              <IconButton
                                sx={{ padding: "0px" }}
                                onClick={() =>
                                  handleDeleteSubContractorRow(idx)
                                }
                                color="error"
                                disabled={disabled}
                              >
                                <DeleteOutlined />
                              </IconButton>
                            </TableCell>
                          ) : null)
                        );
                      })}
                    {/* Render extra vehicle rows below the service row */}
                  </TableRow>
                  {section === "services" &&
                    renderExtraRows &&
                    renderExtraRows(row, idx, handleRemoveVehicle)}
                  {section === "services" &&
                    ["removal"].includes(row?.type?.toLowerCase()) && (
                      <TableRow>
                        <TableCell colSpan={fields.length - 1} />
                        <TableCell align="right">
                          <CustomButton
                            disabled={disabled || !isVehicleRowComplete(idx)}
                            style={{
                              marginRight: "10px",
                              fontSize: "10px",
                              padding: "0px 6px",
                              fontWeight: 600,
                              backgroundColor: "#fff",
                            }}
                            variant="outlined"
                            title="+ More Vehicle"
                            onClick={() => onAddVehicle(idx)}
                          />
                        </TableCell>
                      </TableRow>
                    )}
                </>
              ))
            : null}
          {additionRow}
        </>
      </TableDesign>
    )
  );
};

export default RenderEstimateTable;
